export const MAX_ITEMS_PER_PAGE = 100;
